document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-roicjg-menu][open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('[data-roicjg-menu][open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

(() => {
  let observer;
  function connectHeaderMeasurements() {
    observer?.disconnect();
    const group = document.getElementById('header-group');
    const header = document.querySelector('[data-roicjg-header]');
    if (!group || !header) return;
    const measure = () => {
      document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${group.offsetHeight}px`);
    };
    observer = new ResizeObserver(measure);
    observer.observe(group);
    observer.observe(header);
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connectHeaderMeasurements);
  else connectHeaderMeasurements();
  document.addEventListener('shopify:section:load', connectHeaderMeasurements);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(connectHeaderMeasurements));
})();
